import React, { useState, useEffect } from "react";
import Loading from "../../../../../Common/Loading/Loading";
import { Col, Row, Button } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as SixbellSorDefaultParametersService from "../../../../../../service/SixbellSorDefaultParametersService";
import { ErrorUnexpected, OperationSuccessfully } from "../../../../../../const/Messages";

const initialValues = {
  id: "",
  ignoredCasesLog: false,
  ignoredCasesIr21: false,
  mmeOnlyCheckWithIR21: false,
  vlrOnlyCheckWithIR21: false,
  sgsnOnlyCheckWithIR21: false,
  sgsnIgnoreUsingGtAdress: false,
  vlrIgnoreUsingGtAdress: false,
  sgsnGtAdressUsingPlmnAssociation: false,
  vlrGtAdressUsingPlmnAssociation: false,
  e164AllPrefixes: false,
};

/**
  @author Guilherme Almeida
  @date 08/11/2021
 */
export default function SixbellSorDefaultParameters() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    SixbellSorDefaultParametersService.getSixbellSorDefaultParameters()
        .then((setup) => {
          const data = { 
            ...setup, 
            sgsnIgnoreUsingGtAdress: setup.sgsnIgnoreUsingGtAdress ? "true" : "false", 
            vlrIgnoreUsingGtAdress: setup.vlrIgnoreUsingGtAdress ? "true" : "false",
            e164AllPrefixes: setup.e164AllPrefixes ? "true" : "false"  
          };
          setValues(data);
          setLoading(false);
        })
        .catch(() => {
          history.push("/", { message: ErrorUnexpected, messageType: "error" });
        });
  }, []); // eslint-disable-line

  const schema = Yup.object().shape({});

  function handleSave(values, actions) {

    SixbellSorDefaultParametersService.update(values)
      .then(() => {
        history.push("/settings/report/template/sor/sixbell/default", { message: OperationSuccessfully, messageType: "success" });
      })
      .catch((error) => {
        if (!error || !error.response || !error.response.data) {
          actions.setFieldError("vlrOlnyCheckWithIR21", ErrorUnexpected);
        } else if (error.response.data.title) {
          actions.setFieldError("vlrOlnyCheckWithIR21", error.response.data.title);
        }
        actions.setSubmitting(false);
      });
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <Row>
      <Col>
        <div className="ibox">
          <div className="ibox-title">
            <h5>Sixbell SOR Default Parameters</h5>
          </div>
          <div className="ibox-content">
            <Formik initialValues={values} validationSchema={schema} onSubmit={handleSave}>
              {() => (
                <Form autocomplete="off">
                  <div className="font-weight-bold pt-2 pb-2"><label>GENERAL</label></div>
                  <div className="form-group row">
                    <label
                      htmlFor="ignoredCases"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Ignored Cases:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <div className="d-flex align-items-baseline">
                        <Field type="checkbox" name="ignoredCasesLog"/>
                          <label className="form-check-label pl-2">
                            Ignore value from LOG.
                          </label>
                        <span className="text-danger">
                          <ErrorMessage name="ignoredCasesLog" />
                        </span>
                      </div>
                      <div className="d-flex align-items-baseline">
                        <Field type="checkbox" name="ignoredCasesIr21" />
                        <label className="form-check-label pl-2">
                          Ignore value from IR21.
                        </label>
                        <span className="text-danger">
                          <ErrorMessage name="ignoredCasesIr21" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="e164AllPrefixes"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Global Title:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <div className="form-check form-check-inline">
                        <Field type="radio" name="e164AllPrefixes" value="false" id="boxTruePrefix" className="form-check-input"/>
                        <label className="form-check-label" htmlFor="boxTrue">
                          Single prefix
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <Field type="radio" name="e164AllPrefixes" value="true" id="boxFalsePrefix" className="form-check-input"/>
                        <label className="form-check-label" htmlFor="boxFalse">
                          All prefixes
                        </label>
                      </div>
                      <span className="text-danger">
                        <ErrorMessage name="e164AllPrefixes" />
                      </span>
                    </div>
                  </div>
                  <div className="hr-line-dashed"></div>
                  <div className="font-weight-bold pt-2 pb-2"><label>VLR</label></div>
                  <div className="form-group row">
                    <label
                      htmlFor="vlrOnlyCheckWithIR21"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Ignored Cases Using:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <div className="form-check form-check-inline">
                        <Field type="radio" name="vlrIgnoreUsingGtAdress" value="false" id="boxTrue" className="form-check-input"></Field>
                        <label className="form-check-label" htmlFor="boxTrue">
                          IMSI
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <Field type="radio" name="vlrIgnoreUsingGtAdress" value="true" id="boxFalse" className="form-check-input"></Field>
                        <label className="form-check-label" htmlFor="boxFalse">
                          IMSI + NNGT.
                        </label>
                      </div>
                      <span className="text-danger">
                        <ErrorMessage name="vlrIgnoreUsingGtAdress" />
                      </span>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="vlrGtAdressUsingPlmnAssociation"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      GT Adress:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field type="checkbox" name="vlrGtAdressUsingPlmnAssociation" />
                      <label className="form-check-label pl-2">
                        Use Tadig Association to validate.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="vlrGtAdressUsingPlmnAssociation" />
                      </span>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="vlrOnlyCheckWithIR21"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      IR.21:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field type="checkbox" name="vlrOnlyCheckWithIR21" />
                      <label className="form-check-label pl-2">
                        Check fields only if IR21 file exists.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="vlrOnlyCheckWithIR21" />
                      </span>
                    </div>
                  </div>
                  <div className="hr-line-dashed"></div>
                  <div className="font-weight-bold pt-2 pb-2"><label>SGSN</label></div>
                  <div className="form-group row">
                    <label
                      htmlFor="sgsnIgnoreUsingGtAdress"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Ignored Cases Using:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <div className="form-check form-check-inline">
                        <Field type="radio" name="sgsnIgnoreUsingGtAdress" value="false" id="boxTrue" className="form-check-input"></Field>
                        <label className="form-check-label" htmlFor="boxTrue">
                          IMSI
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <Field type="radio" name="sgsnIgnoreUsingGtAdress" value="true" id="boxFalse" className="form-check-input"></Field>
                        <label className="form-check-label" htmlFor="boxFalse">
                          IMSI + NNGT.
                        </label>
                      </div>
                      <span className="text-danger">
                        <ErrorMessage name="sgsnIgnoreUsingGtAdress" />
                      </span>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="sgsnGtAdressUsingPlmnAssociation"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      GT Adress:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field type="checkbox" name="sgsnGtAdressUsingPlmnAssociation" />
                      <label className="form-check-label pl-2">
                        Use Tadig Association to validate.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="sgsnGtAdressUsingPlmnAssociation" />
                      </span>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="sgsnOnlyCheckWithIR21"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      IR.21:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field type="checkbox" name="sgsnOnlyCheckWithIR21" />
                      <label className="form-check-label pl-2">
                        Check fields only if IR21 file exists.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="sgsnOnlyCheckWithIR21" />
                      </span>
                    </div>
                  </div>
                  <div className="hr-line-dashed"></div>
                  <div className="font-weight-bold pt-2 pb-2"><label>MME</label></div>
                  <div className="form-group row">
                    <label
                      htmlFor="mmeOnlyCheckWithIR21"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      IR.21:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field type="checkbox" name="mmeOnlyCheckWithIR21" />
                      <label className="form-check-label pl-2">
                        Check fields only if IR21 file exists.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="mmeOnlyCheckWithIR21" />
                      </span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Link className="mr-1 btn btn-primary" to="/settings">
                      Cancel
                    </Link>
                    <Button variant="primary" type="submit">
                      Update
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Col>
    </Row>
  );
}
